import { Button } from "@mui/material";

import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import useDeleteConfirmationModal from "../hooks/useDeleteConfirmationModal";

const DeleteConfirmationModal = () => {
  const {
    showDeleteConfirmationModal,
    handleModalClose,
    isProcessing,
    handleDeleteReferringProvider,
  } = useDeleteConfirmationModal();
  return (
    <ModalWrapper
      show={showDeleteConfirmationModal}
      onClose={handleModalClose}
      fullWidth
      title={<span>Delete Referring Provider</span>}
    >
      <div>Are you sure you want to delete this referring provider?</div>
      <div className="d-flex flex-end" style={{ gap: "10px", marginTop: 15 }}>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleModalClose}
          disabled={isProcessing}
        >
          Cancel
        </Button>

        <Button
          color="secondary"
          variant="contained"
          onClick={handleDeleteReferringProvider}
          disabled={isProcessing}
        >
          Confirm
        </Button>
      </div>
    </ModalWrapper>
  );
};

export default DeleteConfirmationModal;
